import { RadiusSearch } from '@/reducers/search';
import { GeoEntry } from '@sbt-web/network/types';

const areSameGeo = (
  previousValue: GeoEntry,
  value: GeoEntry,
  previousValueSearchNearRegions: boolean,
  valueSearchNearRegions: boolean
): boolean => {
  const includeNearbyRegionsMatch =
    previousValueSearchNearRegions === valueSearchNearRegions;

  if (includeNearbyRegionsMatch) {
    type GeoLevelKey = keyof GeoEntry;

    const geoLevelsMatch = (level: GeoLevelKey): boolean => {
      const prevLevelId = previousValue[level]?.id;
      const levelId = value[level]?.id;

      const noLevelId = prevLevelId == undefined && levelId == undefined;

      if (noLevelId) {
        return true;
      }

      const bothLevelIds = prevLevelId != undefined && levelId != undefined;

      if (!bothLevelIds) {
        return false;
      } else {
        return prevLevelId === levelId;
      }
    };

    const keys: GeoLevelKey[] = ['region', 'city', 'town', 'zone'];

    for (let index = 0; index < keys.length; index++) {
      const currentKey: GeoLevelKey = keys[index];

      if (!geoLevelsMatch(currentKey)) {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
};

function areSameRadius(
  object1: RadiusSearch | null,
  object2: RadiusSearch | null
): boolean {
  if (object1 == null && object2 == null) {
    return true;
  } else if (object1 == null || object2 == null) {
    return false;
  }

  const latEqual = object1.center.lat === object2.center.lat;
  const lngEqual = object1.center.lng === object2.center.lng;
  const radiusEqual = object1.radiusMeters === object2.radiusMeters;
  const nameEqual = object1.friendlyName === object2.friendlyName;

  return latEqual && lngEqual && radiusEqual && nameEqual;
}

export { areSameGeo, areSameRadius };
